import { Chip, styled } from "@mui/material"
import { ReactElement, ReactNode } from "react"

const OUTLINED = "outlined"

const StyledChip = styled(Chip)(({ theme, icon }) => ({
    borderRadius: theme.spacing(0.9),
    fontWeight: 500,
    paddingLeft: icon ? theme.spacing(0.5) : 0,
    "&.MuiChip-outlined": {
        border: "1px solid",
        borderColor: theme.palette.grey[500],
    },
    "&.MuiChip-filledPrimary": {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark,
        "& .MuiChip-deleteIcon": {
            color: theme.palette.primary.dark,
        },
    },
    "&.MuiChip-filledSuccess": {
        backgroundColor: theme.palette.success.light,
        color: theme.palette.success.dark,
        "& .MuiChip-deleteIcon": {
            color: theme.palette.success.dark,
        },
    },
    "&.MuiChip-filledError": {
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.dark,
        "& .MuiChip-deleteIcon": {
            color: theme.palette.error.dark,
        },
    },
    "&.MuiChip-filledWarning": {
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.dark,
        "& .MuiChip-deleteIcon": {
            color: theme.palette.warning.dark,
        },
    },
    "&.MuiChip-filledSecondary": {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.dark,
        "& .MuiChip-deleteIcon": {
            color: theme.palette.secondary.dark,
        },
    },
}))

export type AppChipColors =
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "warning"

interface AppChipProps {
    label: ReactNode
    variant: "outlined" | "filled"
    color: AppChipColors
    icon?: (props: any) => ReactElement
    sx?: Record<string, string | number>
    clickable?: boolean
    onDelete?: () => void
}

const AppChip = ({
    label,
    variant,
    icon,
    color,
    sx,
    clickable,
    onDelete,
}: AppChipProps): ReactElement => (
    <StyledChip
        clickable={clickable}
        label={label}
        variant={variant}
        icon={icon ? icon({ fontSize: "30px" }) : undefined}
        color={variant === OUTLINED ? undefined : color}
        sx={{ ...sx }}
        onDelete={onDelete}
    />
)

AppChip.defaultProps = {
    icon: null,
    sx: null,
    clickable: false,
    onDelete: undefined,
}

export default AppChip

// Sort out alert BG
// the flag
// dark mode
